import propTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import {List, ListItem} from 'material-ui/List';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import BusyFlatButton from 'shared/components/BusyFlatButton';
import CloseModalButton from 'shared/components/CloseModalButton';
import * as Colors from 'material-ui/styles/colors';
import routes from 'App/routeConstants';
import { closeDialog, getFolderAndSubFolderImages } from '../helpers';
import { TRASH_FOLDER } from '../consts';

const style = {
  title: {
    color: Colors.gray700,
  },
  warnTitle: {
    color: '#fff',
    background: Colors.red900,
    padding: '14px 24px',
  },
  dialogBody: {
    paddingTop: '30px',
  },
  btn: {
    marginLeft: '8px',
  },
  warnBtnText: {
    color: Colors.red900,
  },
  closeDialogIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default class DeleteFolderDialog extends Component {
  static contextTypes = {
    imageUtils: propTypes.object.isRequired,
  };

  state = {
    error: '',
    busy: false,
  };

  getSmallFolderName(size = 35) {
    const { query: { folderName = ''} } = this.props;
    return `...${folderName.substring(folderName.length - size)}`;
  }

  submit = () => {
    this.setState({ busy: true });
    const { imagesObj, query: { folderName } } = this.props;
    const folderObj = _.get(imagesObj.folders, _.replace(folderName, /\\/gi, '.folders.'));
    if (_.isEmpty(getFolderAndSubFolderImages(folderObj))) {
      this.deleteFolder();
    } else {
      this.moveToTrashFolder(getFolderAndSubFolderImages(folderObj));
    }
  };


  deleteFolder = () => {
    const { query: { folderName }, currentFolder, integrated, changeFolder, router } = this.props;
    const path = _.replace(folderName, /\\/gi, '/');
    this.context.imageUtils.doDeleteFolder({ path }, (data) => {
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message, busy: false });
      } else {
        if (encodeURI(currentFolder).match(encodeURI(folderName))) {
          if (integrated) {
            this.closeDialog();
            changeFolder();
          } else {
            router.replace(routes.MyAccount.AssetManagerBase);
          }
        } else {
          this.closeDialog();
        }
        this.setState({ busy: false });
      }
    });
  }

  moveToTrashFolder = (images) => {
    const files = _.map(_.isArray(images) ? images : [images], (file) => {
      let folder = _.split(file, '/');
      const name = folder.pop();
      folder = folder.join('/');
      return {
        options: 'autorename',
        name,
        type: 'Images',
        folder: folder ? `${folder}/` : '/',
      };
    });
    this.context.imageUtils.doMoveFiles({
      path: `/${TRASH_FOLDER}/`,
      files,
    }, (data) => {
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message, busy: false });
      } else {
        this.deleteFolder();
        this.closeDialog();
      }
    });
  };

  closeDialog = () => {
    if (this.props.integrated) {
      this.props.close();
    } else {
      closeDialog();
    }
  };

  deleteChildFolder() {
    const { foldersName, query: { folderName = ''} } = this.props;
    const deletedFolders = [<div key={0}>The folders that will be delete as well are:</div>];
    _.map(foldersName, item => {
      if (_.startsWith(item, `${folderName}\\`)) {
        deletedFolders.push(<li key={item} style={{ listStyle: 'none', marginLeft: 20 }}>{item}</li>);
      }
    });
    return _.size(deletedFolders) > 1 ? deletedFolders : '';
  }

  render() {
    const { open, query: { folderName = ''} } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        disabled={this.state.busy}
        onClick={this.closeDialog}
      />,
      <BusyFlatButton
        labels={['Yes, delete the folder', 'Deleting folder']}
        busy={this.state.busy}
        onClick={this.submit}
        style={this.state.busy ? {} : style.warnBtnText}
        progressColor={Colors.red900}
        keyboardFocused
        primary
      />,
    ];

    return (
      <Dialog
        title={
          <div>
            <CloseModalButton
              onClick={this.closeDialog}
              style={style.closeDialogIcon}
              white
            />
            {`Delete ${folderName.length > 35 ? this.getSmallFolderName(35) : folderName}?`}
          </div>
        }
        actions={actions}
        actionsContainerStyle={style.actions}
        modal={false}
        open={open}
        onRequestClose={this.closeDialog}
        titleStyle={style.warnTitle}
        style={{zIndex: 1501}}
      >
        <div style={style.dialogBody}>
          This folder will be deleted and all images in it will be moved to Trash.<br/>
          (but if you added images from this folder to a listing or template, it will still be there)
          {this.deleteChildFolder()}
        </div>
      </Dialog>
    );
  }
}

DeleteFolderDialog.propTypes = {
  currentFolder: propTypes.string,
  open: propTypes.bool,
};